export const type = 'form.modalPanel';
